KCVS.Views.UserReportAgreementRowTable =
  template: JST['user_report_rows/agreement_rows_table']()

  mounted: ->
    @fetchAgreementRows()

  data: ->
    rows: []

  methods:
    updateRow: (row) ->
      arrayRow = _.find(@rows, (s_row) -> s_row.id == row.id )
      oldRowIndex = _.indexOf(@rows, arrayRow)
      @rows[oldRowIndex] = row

    fetchAgreementRows: ->
      $.ajax
        url: "/project_partners/#{@.$root.projectPartnerId}/report_agreement_rows.json"
        method: 'GET'
        dataType: 'JSON'
        success: (data) =>
          @rows = data
